
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import { Task } from 'types'
import { useSnackbarContext } from '../../../context/SnackbarProvider/SnackbarProvider'

interface TaskData {
  PK: string
  SK?: string
  orgId: string
  name: string
  type: string
  [key: string]: any
}

interface BatchCreateResponse {
  createdTasks: Task[]
}

const postBatchTasks = async (tasks: TaskData[]): Promise<BatchCreateResponse> => {
  const response = await axios.post(`${baseUrl}/aws/tasks/batch`, { tasks })
  return response.data
}

export const usePostBatchTasks = () => {
  const queryClient = useQueryClient()
  const { showSnackbar } = useSnackbarContext()

  return useMutation<BatchCreateResponse, Error, TaskData[]>({
    mutationFn: postBatchTasks,

    onMutate: async newTasks => {
      await queryClient.cancelQueries({ queryKey: ['tasks_table'] })

      const previousTasks = queryClient.getQueryData<TaskData[]>(['tasks_table'])
      queryClient.setQueryData<TaskData[]>(['tasks_table'], old => [...(old || []), ...newTasks])

      return { previousTasks }
    },

    onError: (error, _newTasks, context: any) => {
      console.error('[usePostBatchTasks] Error:', error)
      if (context?.previousTasks) {
        queryClient.setQueryData(['tasks_table'], context.previousTasks)
      }
      showSnackbar(error.message || 'Batch task creation failed', 'error')
    },

    onSuccess: data => {
      console.log('[usePostBatchTasks] Created Tasks:', data.createdTasks)
      showSnackbar(`Created ${data.createdTasks.length} tasks_table successfully`, 'success')
    },

    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['tasks_table'] })
    },
  })
}
